import {useCallback, useState} from 'react';
import type {FilterValues} from '../constants/filter';
import type {
  SortKeyType,
  SortOptionValue,
  SortOrderType,
} from '../constants/sort';

export type UseSortAndFilterReturn = {
  sortBy: SortKeyType | undefined;
  sortOrder: SortOrderType | undefined;
  filterValues: FilterValues;
  handleSort: (sort: SortOptionValue) => void;
  handleFilter: (filter: FilterValues) => void;
  resetSort: () => void;
  resetFilter: () => void;
  resetAll: () => void;
};

/**
 * ソート・フィルター機能を管理するカスタムhooks
 * エントリー管理のソート・フィルター状態とハンドラをまとめて提供
 */
export const useSortAndFilter = (): UseSortAndFilterReturn => {
  const [sortBy, setSortBy] = useState<SortKeyType | undefined>();
  const [sortOrder, setSortOrder] = useState<SortOrderType | undefined>();
  const [filterValues, setFilterValues] = useState<FilterValues>({});

  /**
   * ソート設定を更新
   */
  const handleSort = useCallback((sort: SortOptionValue) => {
    setSortBy(sort.sortBy);
    setSortOrder(sort.sortOrder);
  }, []);

  /**
   * フィルター設定を更新
   */
  const handleFilter = useCallback((filter: FilterValues) => {
    setFilterValues(filter);
  }, []);

  /**
   * ソート設定をリセット
   */
  const resetSort = useCallback(() => {
    setSortBy(undefined);
    setSortOrder(undefined);
  }, []);

  /**
   * フィルター設定をリセット
   */
  const resetFilter = useCallback(() => {
    setFilterValues({});
  }, []);

  /**
   * ソート・フィルター設定を全てリセット
   */
  const resetAll = useCallback(() => {
    setSortBy(undefined);
    setSortOrder(undefined);
    setFilterValues({});
  }, []);

  return {
    sortBy,
    sortOrder,
    filterValues,
    handleSort,
    handleFilter,
    resetSort,
    resetFilter,
    resetAll,
  };
};
